<!-- 企业级-授权管理-授权中心 -->
<template>
  <div class="CDeviceManageDevice">
    <!-- 内容左边区域 -->
    <div class="contentLeftArea">
      <!-- leftTopArea -->
      <div class="leftTopArea clearfix">
        <span class="text">空间分组</span>
      </div>
      <!-- 空间列表 -->
      <el-tree
        class="defineTree"
        v-loading="sceneData.loading"
        :data="sceneData.list"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        :props="defaultProps"
        :empty-text="sceneData.emptyText"
        @node-click="deviceNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <!-- 自定义icon -->
          <i
            class="defineIcon"
            :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
          </i>
          <span
            class="label"
            :class="data.space_id === deviceData.selected[deviceData.selected.length-1] ? 'selected' : ''"
            @click="getSpaceDeviceList(data.space_id, data.level)">{{ node.label }}</span>
        </span>
      </el-tree>
    </div>

    <!-- 内容右边区域 -->
    <div class="contentRightArea clearfix" v-if="sceneData.list.length !== 0">
      <!-- 按钮区域 -->
      <div class="btnArea">
        <el-button class="btn" @click="operateDialogInfo('addDevice')">添加设备</el-button>
        <el-button class="btn" @click="operateDialogInfo('batchZYDevice')">批量转移设备</el-button>
      </div>

      <!-- 设备列表 -->
      <el-table
        v-loading="deviceData.loading"
        :data="deviceData.list"
        style="width: 100%"
        @selection-change="selectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号">
        </el-table-column>
        <el-table-column
          prop="device_no_id"
          label="设备ID">
        </el-table-column>
        <el-table-column
          prop="device_name"
          label="设备名称">
        </el-table-column>
        <el-table-column
          prop="device_type"
          label="设备类型">
        </el-table-column>
        <el-table-column
          prop="space_name"
          label="设备位置">
        </el-table-column>
        <el-table-column
          label="授权用户">
          <template slot-scope="scope">
            <el-button type="text" @click="operateDialogInfo('alterDevice', scope.row)">设置</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="operateDialogInfo('alterDevice', scope.row)">修改</el-button>
            <el-button type="text" @click="operateDialogInfo('deleteDevice', scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="paging" v-if="deviceData.pageCount > 1">
        <el-pagination
          @current-change="devicePageChange"
          :current-page.sync="deviceData.paging.page"
          layout="prev, pager, next, jumper"
          :page-count="deviceData.pageCount">
        </el-pagination>
      </div>

    </div>

      <!--批量授权用户弹窗-->
      <el-dialog title="批量授权用户" :visible.sync="batchAuthDio" width="800px" @close="closeAuthDio" class="authDio">
        <div class="contDio">
          <div class="step">
            <el-steps :active="actStep" finish-status="success">
              <el-step title="确认授权设备"></el-step>
              <el-step title="选择授权用户"></el-step>
            </el-steps>
          </div>
          <template v-if="actStep==0">
            <div class="tips mt10">
              <p>设备地址：{{area_name}}</p>
              <p>设备数量：{{total_equi}}个</p>
            </div>
            <div class="dioTable mt10">
              <el-table :data="batchData" style="width: 100%">
                <el-table-column type="index" label="序号" width="70"></el-table-column>
                <el-table-column prop="device_no_id" label="设备ID"></el-table-column>
                <el-table-column prop="device_name" label="设备名称"></el-table-column>
                <el-table-column prop="device_type" label="设备类型"></el-table-column>
                <el-table-column label="操作" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" @click="delbacthDevice(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
          <template v-else>
            <el-form ref="form" :rules="rules2" :model="bacthform" label-width="90px" class="mt10">
              <el-form-item label="授权时间:">
                <el-select v-model="bacthform.timeType" class="w110">
                  <el-option
                    v-for="(item, index) in typeList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <template v-if="bacthform.timeType==1">
                <el-date-picker
                  v-model="bacthform.time"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions">
                </el-date-picker>
                </template>
              </el-form-item>
              <el-form-item label="使用次数:">
                <el-checkbox v-model="bacthform.isCount">无限次数</el-checkbox>
                <template v-if="bacthform.isCount == false">
                <el-input v-model="bacthform.frequency" class="w110"></el-input><span> 次</span>
                </template>
              </el-form-item>

              <div class="tit flex">
                <div>授权用户:</div>
                <div class="col6">已勾选：{{bacthform.userInfo.length}}人</div>
              </div>
              <div class="authUserList flex">
                <div class="userTree">
                  <el-tree
                  ref="tree2"
                  class="defineTree"
                  :data="departBacthList"
                  highlight-current
                  default-expand-all
                  node-key="id"
                  :expand-on-click-node="false"
                  :props="adminTreeProp"
                  @node-click="getUserList">
                    <span class="custom-tree-node" slot-scope="{ node,data }">
                      <i
                        class="defineIcon"
                        :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                      </i>
                      <span class="label" :class="data.id === treeCurrent ? 'selectedTree' : ''">{{ node.label }}</span>
                    </span>
                  </el-tree>
                </div>
                <div class="checkList">
                  <div class="search">
                    <el-input size="small" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="bacthform.search" @input="searchUser"></el-input>
                  </div>
                  <el-checkbox :indeterminate="isIndeterminateBatch" v-model="checkAllBatch" @change="handleCheckAllBatch">全选</el-checkbox>
                  <el-checkbox-group v-model="bacthform.userInfo" @change="handleCheckedCitiesBatch">
                    <el-checkbox v-for="(item,index) in transList" :label="item.user_id" :key="index">{{item.user_name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              <!-- <el-form-item label="授权用户:">
                <el-select v-model="bacthform.userType" @change="getUserList">
                  <el-option
                    v-for="(item, index) in ustypeList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-cascader
                  :options="departBacthList"
                  v-model="bacthform.department"
                  @change="getUserList"
                  :props="cascaProps"
                  change-on-select
                  v-if="bacthform.userType=='0'">
                </el-cascader>
              </el-form-item> -->
            </el-form>
            <!-- <el-transfer
              style="text-align: left; display: inline-block"
              v-model="bacthform.userInfo"
              filterable
              filter-placeholder="请输入搜索内容"
              :titles="['未选择用户', '已选择用户']"
              :button-texts="['to left', 'to right']"
              :format="{
                noChecked: '${total}',
                hasChecked: '${checked}/${total}'
              }"
              :data="transList"
              :props="transProps"
              :render-content="renderFunc"
              :filter-method="filterMethod">
            </el-transfer> -->
          </template>
        </div>
        <span slot="footer" class="dialog-footer">
          <template v-if="actStep==0">
            <el-button @click="closeAuthDio">取消</el-button>
            <el-button type="primary" @click="nextStep" v-if="isNoStep==false">下一步</el-button>
            <el-button type="primary" v-else disabled>下一步</el-button>
          </template>
          <template v-else>
            <el-button @click="actStep=0">上一步</el-button>
            <el-button type="primary" @click="submitBacth('form')">确定</el-button>
          </template>
        </span>
      </el-dialog>

      <!--授权用户-->
      <el-dialog title="授权用户" :visible.sync="AuthDio" width="700px" class="authDio" @close="closeAuthDio">
        <div class="contDio">
          <el-form ref="form2" :rules="rules2" :model="authUserform" label-width="80px">
              <el-form-item label="设备信息:" class="bd">
                <div class="flex">
                  <div class="item">设备ID：<span>{{authUserform.device_no_id}}</span></div>
                  <div class="item">设备名称：<span>{{authUserform.device_name}}</span></div>
                  <div class="item">设备类型：<span>{{authUserform.device_type}}</span></div>
                </div>
              </el-form-item>
              <template v-if="authStep == '2'">
              <div class="dioTit">
                <p class="text">请选择授权箱格</p>
                <p class="text s" v-if="authUserform.device_type_code == 'OFFICIALDEPOSIT'">共有{{authUserform.current_count}}人使用该设备，还可授权{{authUserform.count-authUserform.current_count}}人</p>
              </div>
              <div class="dioList">
                <div class="item" v-for="(item,index) in boxList" :key="index">
                  <div>
                    {{item.box_number}}
                    <template v-if="item.box_size == 'A'">(极大)</template>
                    <template v-if="item.box_size == 'B'">(大)</template>
                    <template v-if="item.box_size == 'C'">(中)</template>
                    <template v-if="item.box_size == 'D'">(小)</template>
                    <template v-if="item.box_size == 'E'">(极小)</template>
                  </div>
                  <div>已授权:{{item.user_info}}</div>
                  <el-button type="primary" size="small" @click="authBox(item.box_number)">授权</el-button>
                </div>
              </div>
              </template>
              <template v-else>
              <el-form-item label="授权时间:">
                <el-select v-model="authUserform.timeType" class="w110">
                  <el-option
                    v-for="(item,index) in typeList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <template v-if="authUserform.timeType=='1'">
                <el-date-picker
                  v-model="authUserform.time"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions">
                </el-date-picker>
                </template>
              </el-form-item>
              <el-form-item label="使用次数:">
                <el-checkbox v-model="authUserform.isCount">无限次数</el-checkbox>
                <template v-if="authUserform.isCount==false">
                <el-input v-model="authUserform.frequency" class="w110"></el-input><span> 次</span>
                </template>
              </el-form-item>
              <el-form-item label="分享权限:">
                <el-checkbox v-model="authUserform.is_forbid">禁止分享</el-checkbox>
                <span class="hintColor">勾选后，授权用户将无法使用分享设备权限功能</span>
              </el-form-item>
              <div class="tit flex">
                <div>授权用户:<span class="hintColor" style="margin-left:20px;" v-if="authUserform.device_type_code === 'FEIBIFACE'">未上传人脸照片的用户无法授权{{authUserform.device_type}}</span></div>
                <div class="col6">已勾选：{{authUserform.userInfo.length}}人</div>
              </div>
              <div class="authUserList flex">
                <div class="userTree">
                  <el-tree
                  ref="tree2"
                  class="defineTree"
                  :data="departList"
                  highlight-current
                  default-expand-all
                  node-key="id"
                  :expand-on-click-node="false"
                  :props="adminTreeProp"
                  @node-click="getUserList">
                    <span class="custom-tree-node" slot-scope="{ node,data }">
                      <i
                        class="defineIcon"
                        :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                      </i>
                      <span class="label" :class="data.id === treeCurrent ? 'selectedTree' : ''">{{ node.label }}</span>
                    </span>
                  </el-tree>
                </div>
                <div class="checkList">
                  <div class="search">
                    <el-input size="small" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="authUserform.search" @input="searchUser"></el-input>
                  </div>
                  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                  <el-checkbox-group v-model="authUserform.userInfo" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="(item,index) in transList" :label="item.user_id" :key="index" :disabled="authUserform.device_type_code === 'FEIBIFACE' && item.is_face === 0">{{item.user_name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              </template>
              <!-- <el-form-item label="授权用户:">
                <el-select v-model="authUserform.userType" @change="getUserList">
                  <el-option
                    v-for="(item,index) in ustypeList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-cascader
                  :options="departList"
                  v-model="authUserform.department"
                  @change="getUserList"
                  change-on-select
                  :props="cascaProps"
                  v-if="authUserform.userType=='0'">
                </el-cascader>
              </el-form-item> -->
            </el-form>
            <!-- <el-transfer
              style="text-align: left; display: inline-block"
              v-model="authUserform.userInfo"
              filterable
              filter-placeholder="请输入搜索内容"
              :titles="['未选择用户', '已选择用户']"
              :button-texts="['to left', 'to right']"
              :format="{
                noChecked: '${total}',
                hasChecked: '${checked}/${total}'
              }"
              :data="transList"
              :props="transProps"
              :render-content="renderFunc"
              :filter-method="filterMethod">
            </el-transfer> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeAuthDio">取消</el-button>
          <template v-if="(authUserform.device_type == '办公魔方柜' || authUserform.device_type == '物联信报箱' || authUserform.device_type_code == 'OFFICIALDEPOSIT') && authStep == '1'">
          <el-button type="primary" @click="authStep = '2'">上一步</el-button>
          </template>
          <el-button type="primary" @click="submitAdd('form2')" v-if="authStep == '1'">确定</el-button>
        </span>
      </el-dialog>

      <!--设置管理员-->
      <el-dialog title="设置管理员" :visible.sync="setAdminDio" width="600px" class="authDio">
        <div class="contDio">
          <el-form ref="form3" :model="authform" label-width="80px">
              <el-form-item label="设备信息:">
                <div class="flex">
                  <div class="item">设备ID：<span>{{authform.device_no_id}}</span></div>
                  <div class="item">设备名称：<span>{{authform.device_name}}</span></div>
                  <div class="item">设备类型：<span>{{authform.device_type}}</span></div>
                </div>
              </el-form-item>
            </el-form>
            <div class="tit">授权用户:</div>
            <div class="authUser flex">
              <div class="userTree">
                <el-tree
                ref="tree2"
                class="defineTree"
                :data="authform.department"
                highlight-current
                default-expand-all
                node-key="id"
                :expand-on-click-node="false"
                :props="adminTreeProp"
                @node-click="userClick">
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <i
                      class="defineIcon"
                      :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                    </i>
                    <span class="label">{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
              <div class="checkList">
                <!-- 车位锁显示 -->
                <div class="topArea" v-if="authform.device_type_code == 'CPL'">
                  <div class="search">
                    <el-input size="small" placeholder="请输入姓名或手机号进行搜索" prefix-icon="el-icon-search" v-model="authform.search" @input="searchAdminUser"></el-input>
                  </div>
                  <div class="titArea">
                    <p class="left">姓名</p>
                    <p class="right">授权功能点</p>
                  </div>
                </div>
                <div class="checkItemBox" :class="[authform.device_type_code]">
                  <div class="checkItem" v-for="(item,index) in authform.checkList" :key="index" @click="authform.activeIndex = index">
                    <el-checkbox class="checkbox user_name" v-model="item.userChecked" @change="userCheckedChange">{{item.user_name}}</el-checkbox>
                    <template v-if="authform.device_type_code == 'CPL'">
                      <el-checkbox class="checkbox switch" v-model="item.switchChecked" @change="switchCheckedChange">开关</el-checkbox>
                      <el-checkbox class="checkbox authorize" v-model="item.authorizeChecked" @change="authorizeCheckedChange">授权</el-checkbox>
                    </template>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addDeviceAdmin">确定</el-button>
        </span>
      </el-dialog>

  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { userApi, sceneApi, authApi } from "../../../../../static/js/api.js"

  export default {
    name: 'CDeviceManageDevice',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        checkList:[],
        // 位置列表数据
        sceneData: {
          // 位置列表
          list: [],
          loading: false,
          selected:'',
        },
        // 树形控件配置
        defaultProps: {
          id:'space_id',
          children: 'children',
          label: 'space_name'
        },

        space_id:[],//空间id
        authData:[],//授权列表
        tableLoading:false,//table是否刷新
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        batchAuthDio:false,//批量弹窗状态
        actStep:0,//步骤
        equipData:[],//设备数据
        bacthform:{
          timeType:'0',//时间类型
          time:'',//时间段
          frequency:'',//使用次数
          isCount:true,//是否无限次数
          userType:'0',//授权用户
          department:[],
          userInfo:[],
          deviceSeList:[],//选中设备
          search:'',//搜索字段
          authUserType:'0',
          device_type_code:'',
        },
        checkAllBatch: false,
        isIndeterminateBatch: false,

        total_equi:0,//总设备数
        area_name:'',//地址
        departBacthList:[],
        isNoStep:false,//下一步是否置灰

        batchData:[],//批量列表

        //时间类型数组
        typeList:[{
          id:'1',
          name:'指定时间',
        },{
          id:'0',
          name:'永久',
        }],
        //授权用户数组
        ustypeList:[{
          id:'0',
          name:'内部员工',
        },
        // {
        //   id:'1',
        //   name:'会员用户',
        // },
        {
          id:'2',
          name:'临时用户',
        }],
        departList:[],//部门级联列表
        //级联选择器配置
        cascaProps:{
          value:'id',
          label:'name',
        },
        //穿梭框渲染函数
        transList:[],
        //穿梭框配置
        transProps:{
          key:'user_id',
          label:'user_name',
        },

        AuthDio:false,//用户授权弹窗
        authUserform:{
          space_id:'',//空间id
          device_no_id:'',//设备号
          device_type:'',//设备类型
          device_name:'',//设备名
          timeType:'0',//时间类型
          time:'',//时间段
          frequency:'',//使用次数
          isCount:true,//是否无限次数
          is_forbid: false, // 是否禁止分享设备权限
          userType:'0',//授权用户
          department:[],
          userInfo:[],//勾选中列表
          boxNum:'',//箱格号
          search:'',//搜索字段
          authUserType:'0',
          device_type_code:'',
          current_count: '', // 当前授权人数（办公寄存柜专用）
          count: '',  // 可授权总人数（办公寄存柜专用）
        },
        boxList:[],//箱格列表
        allAuthUser:[],
        checkAll: false,
        isIndeterminate: false,
        authStep:'1',
        treeCurrent:'',

        rules2:{
          frequency:[
            { required: true, message: '请输入使用次数', trigger: 'blur' },
          ]
        },

        setAdminDio:false,//设置管理员弹窗
        authform:{
          activeIndex: '',
          search: '', // 用户列表搜索关键字
          space_id:'',//空间ID
          device_no_id:'',//设备号
          device_type:'',//设备类型
          device_type_code: '', //设备类型code
          device_name:'',//设备名
          department:[],
          checkList: [],
          userInfo:[],
        },
        pickerOptions:{
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的 
          }
        },
        adminTreeProp:{
          id:'id',
          label:'name',
          children:'children',
        },
        definSele:[],
        
      };
    },
    mounted(){

    },
    created: async function () {
      this.getSceneList();
    },
    methods: {
      //箱格授权
      authBox(boxnumber){
        this.getDepartmentList(2);
        this.authStep = '1'
        this.authUserform.userInfo = []
        this.isIndeterminate = false
        this.authUserform.boxNum = boxnumber
      },

      //全选(批量)
      handleCheckAllBatch(val) {
        // console.log('全选',val)
        var arr = []
        for(var i in this.transList){
          arr.push(this.transList[i].user_id)
        }
        arr = Array.from(new Set(arr))
        // console.log(arr)
        this.bacthform.userInfo = val ? arr : [];
        this.isIndeterminateBatch = false;
      },
      //选择多个（批量）
      handleCheckedCitiesBatch(value) {
        // console.log('单选',value)
        let checkedCount = value.length;
        this.checkAllBatch = checkedCount === this.transList.length;
        this.isIndeterminateBatch = checkedCount > 0 && checkedCount < this.transList.length;
      },

      //全选
      handleCheckAllChange(val) {
        // console.log('全选',val)
        var arr = []
        for(var i in this.transList){
          if (this.transList[i].is_face === 1) { arr.push(this.transList[i].user_id) }
        }
        arr = Array.from(new Set(arr))
        // console.log(arr)
        this.authUserform.userInfo = val ? arr : []
        this.isIndeterminate = false
      },
      //选择多个
      handleCheckedCitiesChange(value) {
        // console.log('单选',value)
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.transList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.transList.length;
      },
      //设置表格多选框是否可选
      checkboxT(row,index){
        // console.log('tag', row)
        // 只有周转柜、门禁和插座可勾选批量授权
    		if(row.device_type_code =='TURN' || row.device_type_code == 'ACCESS' || row.device_type_code == 'SOCKET'){
    			return true
    		}else{
    			return false
    		}
    	},
      //获取table选中
      handleSelectionChange(val) {
        this.batchData = val;
      },
      //提交批量授权
      submitBacth(formName){
        let that = this;
        that.$refs[formName].validate((valid) => {
          if (valid) {
            that.batchAddAuthorizedUser();
          }else {
            return false;
          }
        });
      },
      //添加批量授权
      async batchAddAuthorizedUser(){
        let that = this;
        var data={
          'space_id': that.space_id.join(''),
          'device_no_id': that.bacthform.deviceSeList,
          // 'use_count': that.bacthform.frequency,
          'use_timetype': that.bacthform.timeType,
          'user_type': that.bacthform.userType,
          'user_list': that.bacthform.userInfo,
        }
        if(that.bacthform.isCount == true){
          data.use_count='-1'
        }else{
          var re = /^[1-9]+[0-9]*]*$/
          if(!re.test(that.bacthform.frequency)){
            showToast('使用次数只能输入正整数')
            return
          }else{
            data.use_count=that.bacthform.frequency
          }
        }
        if(that.bacthform.timeType == 1){
          data.start_usetime=that.bacthform.time[0];//开始时间
          data.end_usetime=that.bacthform.time[1];//结束时间
        }
        let res = await authApi.batchAddAuthorizedUser(data)
        if (res.meta.code === 200) {

          that.batchAuthDio = false;
          showToast('批量添加成功！')
        } else {
          showToast(res.meta.message)
        }
      },

      //下一步
      nextStep(){
        let that = this;
        that.batchData.forEach(function (value) {
          that.bacthform.deviceSeList.push(value.device_no_id)
        });
        that.getDepartmentList(1)
        that.actStep=1
      },
      //删除设备
      delbacthDevice(index){
        if(this.batchData.length<=1){
          showToast('最少保留一个设备！')
        }else{
          this.batchData.splice(index,1);
        }
        
      },
      //打开批量弹窗
      openBatchAuth(){
        if(this.batchData == ''){
          showToast('请先勾选要授权的设备')
          // this.$message.warning('请先勾选要授权的设备')
          return
        }
        this.actStep=0;//步骤
        this.equipData=[];//设备数据
        this.bacthform = {
          timeType:'0',//时间类型
          isCount:true,//是否无限次数
          userInfo:[],
          deviceSeList:[],//选中设备
          search:'',//搜索字段
        }
        this.checkAllBatch = false
        this.isIndeterminateBatch = false

        this.getSpaceDeviceAll();
        this.batchAuthDio = true;
        
      },
      //通过位置获取所有设备
      async getSpaceDeviceAll(){
        let that = this;
        let data={
          'space_id': that.space_id.join(''),
        }
        let res = await authApi.getSpaceDeviceAll(data)
        if (res.meta.code === 200) {
          that.equipData = res.data.list
          that.total_equi = parseInt(res.data.count)
          that.area_name = res.data.area_name.replace(/\//g, "")
          if(res.data.list==''){
            that.isNoStep=true;
          }else{
            that.isNoStep=false;
          }
        } else {
          showToast(res.meta.message)
        }
      },
      //提交管理员
      async addDeviceAdmin(){
        let that = this
        // 获取要设置的用户列表
        let checkList = that.authform.checkList, user_list = []
        checkList.forEach((item, index)=>{
          let userItem = {}
          if (item.userChecked) {
            userItem = {
              user_id: item.user_id,
              auth_node: (item.switchChecked&&item.authorizeChecked) ? 0 : 
                                  (!item.switchChecked&&item.authorizeChecked) ? 1 :
                                  (item.switchChecked&&!item.authorizeChecked) ? 2 : ''
            }
            user_list.push(userItem)
          }
        })
        let data={
          'space_id': that.authform.space_id,
          'device_no_id': that.authform.device_no_id,
          'user_list': user_list,
        }

        // if(data.user_list.length == 0){
        //   showToast('请选择管理员！')
        //   return
        // }
        
        // console.log('data', data)
        // return
        let res = await authApi.addDeviceAdmin(data)
          if (res.meta.code === 200) {
            that.authform={
              activeIndex: '',
              search: '', // 用户列表搜索关键字
              space_id:'',//空间ID
              device_no_id:'',//设备号
              device_type:'',//设备类型
              device_type_code:'',//设备类型
              device_name:'',//设备名
              department:[],
              userInfo:[],
              checkList: []
            };
            that.setAdminDio=false
            showToast('设置成功！')
          } else {
            showToast(res.meta.message)
          }
      },
      //设置管理员-选择部门
      userClick(data){
        // console.log(data)
        this.getUserToDepart(data.id)
      },
      //打开管理员设置
      async openAdminDio(index){
        this.authform.search = ''
        this.authform.space_id=this.authData[index].space_id
        this.authform.device_no_id=this.authData[index].device_no_id
        this.authform.device_type=this.authData[index].device_type
        this.authform.device_type_code=this.authData[index].device_type_code
        this.authform.device_name=this.authData[index].device_name
        this.getDepartmentList(3);
        this.getUserToDepart(0)
        this.setAdminDio=true;
      },
      // 关键字搜索用户（手机号、名称）
      searchAdminUser () {
        let vm = this
        // console.log('keywords', vm.authform.search)
        let keywords = vm.authform.search
        let checkList = [...vm.checkList]
        let newList = []
        vm.authform.checkList = []
        checkList.forEach(function (item, index) {
          let newItem = {}
          if (item.phone_no.includes(keywords)) { newItem = item }
          if (item.user_name.includes(keywords)) { newItem = item }
          if (newItem.user_id) { newList.push(newItem)  }
          // console.log('newItem', newItem)
        })
        vm.authform.checkList = newList
        // console.log('newList', newList)
      },
      // 通过部门获取用户(设置管理员)
      async getUserToDepart(departId){
        let that = this;
        that.authform.checkList = []
        let data={
          'device_no_id': that.authform.device_no_id,
          'department_id': departId,
        }
        let res = await authApi.getAdminUserList(data)
        if (res.meta.code === 200) {
          let list = [...res.data.list]
          res.data.list.forEach(function (value, index) {
            // console.log(value.is_admin)
            let auth_node = value.auth_node
            list[index].userChecked = value.is_admin == 1
            list[index].switchChecked = (value.is_admin == 1) && (auth_node == 0 || auth_node == 2)
            list[index].authorizeChecked = (value.is_admin == 1) && (auth_node == 0 || auth_node == 1)
          })
          that.checkList = list
          that.authform.checkList = list
          console.log('所有用户列表', list)
          // console.log(that.authform.userInfo)
        } else {
          showToast(res.meta.message)
        }
      },
      // 监听是否选择用户名称
      userCheckedChange (value) {
        let vm = this
        // console.log('value', value)
        // console.log('authform.activeIndex', this.authform.activeIndex)
        let index = vm.authform.activeIndex
        let newItem = vm.authform.checkList[index]
        let userChecked = newItem.userChecked
        // 若选择用户，默认勾选开关和授权的两个权限
        newItem.switchChecked = userChecked
        newItem.authorizeChecked = userChecked
        vm.$set(vm.authform.checkList, index, newItem)
        // console.log('index::', index, vm.authform.checkList[index].userChecked)
      },
      // 监听是否选择用户开门
      switchCheckedChange (value) {
        let vm = this
        let index = vm.authform.activeIndex
        let newItem = vm.authform.checkList[index]
        let authorizeChecked = newItem.authorizeChecked
        newItem.userChecked = authorizeChecked == false && value == false ? false : true
        vm.$set(vm.authform.checkList, index, newItem)
      },
      // 监听是否选择用户授权
      authorizeCheckedChange (value) {
        let vm = this
        let index = vm.authform.activeIndex
        let newItem = vm.authform.checkList[index]
        let switchChecked = newItem.switchChecked
        newItem.userChecked = switchChecked == false && value == false ? false : true
        vm.$set(vm.authform.checkList, index, newItem)
      },

      //添加授权用户
      submitAdd(formName){
        let that = this;
        that.$refs[formName].validate((valid) => {
          if (valid) {
            that.addAuthorizedUser();
          }else {
            return false;
          }
        });
      },
      async addAuthorizedUser(){
        let that = this;
        var data = {
          'space_id': that.authUserform.space_id,//空间id
          'device_no_id': that.authUserform.device_no_id,//设备号
          // 'use_count': that.authUserform.frequency,//使用次数
          'use_timetype': that.authUserform.timeType,//授权时间类型
          'user_type': that.authUserform.userType,//用户类型
          'user_list': that.authUserform.userInfo,//用户id
          'is_share': that.authUserform.is_forbid ? 0 : 1, // 是否禁止分享(1允许分享，0不允许)
        }
        //判断是否是魔方柜或者信报箱
        if(that.authUserform.device_type_code == 'MAGICCUBE' || that.authUserform.device_type_code == 'IOTLETTERBOX' || that.authUserform.device_type_code == 'OFFICIALDEPOSIT'){
          data.box_number = that.authUserform.boxNum;//箱格号
          if (that.authUserform.device_type_code == 'OFFICIALDEPOSIT' && that.authUserform.current_count == 150) {
            showToast('此设备授权人数已达到上限150人')
            return
          }
        }
        if(that.authUserform.isCount == true){
          data.use_count='-1'
        }else{
          var re = /^[1-9]+[0-9]*]*$/
          if(!re.test(that.authUserform.frequency)){
            showToast('使用次数只能输入正整数')
            return
          }else{
            data.use_count=that.authUserform.frequency
          }
        }
        if(that.authUserform.timeType == 1){
          data.start_usetime=that.authUserform.time[0];//开始时间
          data.end_usetime=that.authUserform.time[1];//结束时间
        }
        // console.log('authUserform', that.authUserform)
        // console.log('data', data)
        // return
        let res = await authApi.addAuthorizedUser(data)
        if (res.meta.code === 200) {
          that.closeAuthDio()
          // showToast(res.meta.message)
          showToast('授权用户成功！')
        } else {
          showToast(res.meta.message)
        }  
      },
      //打开用户授权
      openAuthDio(index){
        this.authUserform={
          timeType:'0',//时间类型
          isCount:true,//是否无限次数
          userInfo:[],//勾选中列表
          boxNum:'',//箱格号
          search:'',//搜索字段
          is_forbid: false, // 是否禁止分享
        }
        this.boxList=[];//箱格列表
        this.allAuthUser=[]
        this.checkAll= false;
        this.isIndeterminate=false;
        this.authStep = '1'
        this.authUserform.space_id=this.authData[index].space_id
        this.authUserform.device_no_id=this.authData[index].device_no_id
        this.authUserform.device_type=this.authData[index].device_type
        this.authUserform.device_name=this.authData[index].device_name
        this.authUserform.device_type_code = this.authData[index].device_type_code
        //判断是否是魔方柜、信报箱或办公寄存柜
        let codeValue = this.authUserform.device_type_code
        if( codeValue == 'MAGICCUBE' || codeValue == 'IOTLETTERBOX' || codeValue == 'OFFICIALDEPOSIT'){
          this.authStep = '2'
          this.getAuthBox(this.authData[index].device_no_id)
        }else{
          this.getDepartmentList(2);
        }
        this.AuthDio = true;
      },
      //获取箱格授权信息
      async getAuthBox(id){
        let that = this;
        const dataObj = {
          'device_no_id': id,
        }
        const res = await authApi.getAuthBox(dataObj);
        if(res.meta.code == 200 ){
          that.boxList = [...res.data.list]
          that.authUserform.current_count = res.data.current_count 
          that.authUserform.count = res.data.count 
        }else{
          showToast(res.meta.message);
        }
      },
      //关闭用户授权
      closeAuthDio(){
        let that = this;
        if(this.AuthDio == true){
          that.authUserform={
            device_no_id:'',//设备号
            device_type:'',//设备类型
            device_name:'',//设备名
            timeType:'1',//时间类型
            time:'',//时间段
            frequency:'',//使用次数
            isCount:false,//是否无限次数
            userType:'0',//授权用户
            department:[],
            userInfo:[],
          };
          that.departList=[];
          that.transList=[];
          that.AuthDio = false;
        }else if(this.batchAuthDio == true){
          that.bacthform={
            timeType:'1',//时间类型
            time:'',//时间段
            frequency:'',//使用次数
            isCount:false,//是否无限次数
            userType:'0',//授权用户
            department:[],
            userInfo:[],
            deviceSeList:[],//选中设备
          };
          that.departBacthList=[];
          that.transList=[];
          that.batchAuthDio = false;
        }
      },
      //穿梭框数据列渲染
      renderFunc(h, option) {
        return h('span',option.phone_no+'-'+option.user_name)
      },
      //穿梭框自定义搜索逻辑
      filterMethod(query, item) {
        // console.log(query,item)
        return item.phone_no.indexOf(query) > -1 ||item.user_name.indexOf(query) > -1;
      },
      //点击节点
      getNodeList(data){
        // if (data.level < 1) return // 汕头移动需注释
        this.sceneData.selected = data.space_id
        this.space_id=data.space_id.split(',')
        this.getDriveList(1)
      },
      
      // 获取用户列表
      async getUserList(node){
        // console.log(node)
        let that = this;
        this.treeCurrent = node.id
        let data = {}
        if(that.batchAuthDio==true){
          // data.user_type = that.bacthform.userType;
          if(that.bacthform.authUserType != node.userType){
            that.bacthform.userInfo = []
            that.isIndeterminateBatch = false
          }
          that.bacthform.authUserType = node.userType
          data.user_type = node.userType
          data.is_bath = true;
          data.space_id = that.space_id.join('');
          if(node.userType==0){
            data.department_id = node.id
          }
        }else{
          if(that.authUserform.authUserType != node.userType){
            that.authUserform.userInfo = []
            that.isIndeterminate = false
          }
          that.authUserform.authUserType = node.userType
          data.user_type = node.userType
          data.is_bath = false;
          data.space_id = that.authUserform.space_id;
          data.device_no_id = that.authUserform.device_no_id;
          data.box_number = that.authUserform.boxNum;
          if(node.userType=='0'){
            if(node.id == '-1'){
              data.department_id = '0'
            }else{
              data.department_id = node.id
            }
          }
        }
        let res = await authApi.getUserList(data)
        if (res.meta.code === 200) {
          // console.log(res.data.list)
          // that.transList = res.data.list
          that.allAuthUser = res.data.list
          that.searchUser()
        } else {
          showToast(res.meta.message)
        }
      },
      //筛选用户
      searchUser(){
        let that = this;
        var allAuthUser = this.allAuthUser
        var searchList = []
        for(var i in allAuthUser){
          if(that.authUserform.search!=''){
            if(allAuthUser[i].user_name.indexOf(that.authUserform.search) != -1){
              searchList.push(allAuthUser[i])
            }
          }else if(that.bacthform.search!=''){
            if(allAuthUser[i].user_name.indexOf(that.bacthform.search) != -1){
              searchList.push(allAuthUser[i])
            }
          }else{
            searchList = allAuthUser
          }
        }
        // console.log('searchList',searchList)
        this.transList = searchList
      },
      //递归遍历树形数组
      forTree(data){
        var that = this
        for(var i in data){
          data[i].userType = '0'
          if(data[i].children){
            that.forTree(data[i].children)
          }
        }
      },
      //获取部门列表
      async getDepartmentList(status) {
        let that = this
        let res = await userApi.getDepartmentList()
        if (res.meta.code === 200) {
          if(status == 3){
            that.authform.department = res.data
            that.definSele=res.data[0].id.split(',')
          }else if(status == 2 || status == 1){
            that.departList = []
            that.departBacthList = []
            var arr = []
            that.forTree(res.data)
            const obj = {
              id:'-1',
              name:'内部员工',
              children: res.data,
              userType:'0',
            }
            arr.push(obj)
            const obj2 = {
              id:'-2',
              name:'临时员工',
              userType:'2'
            }
            arr.push(obj2)

            if(status == '2'){
              that.departList = arr
            }else{
              that.departBacthList = arr
            }
            that.getUserList(obj)
            
          }
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取位置列表
      getSceneList: async function () {
        let vm = this
        let res = await sceneApi.space()
        if (res.meta.code === 200) {
          // console.log(res.data)
          if(res.data!=''){
            vm.sceneData.list = res.data
            vm.sceneData.selected = res.data[0].space_id
            // vm.sceneData.selected = res.data[0].children[0].children[0].space_id // 汕头移动需注释
            // vm.space_id = res.data[0].space_id.split(',')
            vm.getDriveList(1)
            vm.$nextTick(function(){
              vm.$refs.tree.setCurrentKey(vm.space_id.join(''))
            })
          }
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取设备列表
      getDriveList: async function (curr,limits) {
        let that = this
        that.tableLoading=true
        let data={
          'space_id': that.space_id.join(''),//空间ID
          'perPage': limits ? limits : that.page,//每页显示多少条数据
          'page': curr ? curr : that.curr,//当前页
        }
        let res = await sceneApi.getSpaceDeviceList(data)
        if (res.meta.code === 200) {
          that.authData = res.data.list
          that.total = parseInt(res.data.totalPage)
          that.tableLoading=false
        } else {
          that.tableLoading=false
          showToast(res.meta.message)
        }
      },
      //点击当前页调用接口
      CurrentChange(val){
        this.curr = val
        this.getDriveList(val)
      },
      //查看已授权用户
      toBeauthUser(index){
        let that = this;
        let navBarActive = [{function_tab: 'CBeAuthorizedUser', function_name: '已授权用户'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/CBeAuthorizedUser',
          query: {
            'space_id': that.authData[index].space_id,
            'device_no_id': that.authData[index].device_no_id,
            'device_type': that.authData[index].device_type,
            'device_name': that.authData[index].device_name,
          }
        })
      },
    },
    watch: {
      //设置管理员弹窗树形默认选中
      definSele(){
        let that = this;
        this.$nextTick(function(){
          that.$refs.tree2.setCurrentKey(that.definSele.join(''))
        })
      }
    }
  }
</script>

<style lang="scss">
.CDeviceManageDevice{
  .bd{
    border-bottom: 1px solid #ddd;
  }
  .w110{ width: 110px;}
  .mt10{ margin-top: 10px;}
  .el-transfer-panel__list .el-checkbox{
    display: block;
  }
  .contDio{
    .selectedTree{
      font-weight: bold;
    }
    .authUserList{
      border: 1px solid #eee;
      align-items: flex-start !important;
      .userTree{
        width: 44%;
        height: 300px;
        overflow-y: auto;
        border-right: 1px solid #eee;
        flex-shrink: 0;
      }
      .checkList{
        flex-grow: 1;
        .search{
          text-align: center;
          padding: 6px 0 0;
          .el-input{
            width: 70%;
            .el-input__inner{
              border-radius: 16px;
            }
          }
        }
        .el-checkbox{
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          flex-direction: row-reverse;
          padding-right: 16px;
          .el-checkbox__label{
            padding-left:16px;
          }
        }
        .el-checkbox-group{
          height: 227px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
      }
    }
    .el-date-editor--daterange.el-input__inner{ width: 330px;}
    .el-transfer-panel{
      width: 300px;
    }
    .el-transfer-panel__body{
      height: 286px;
    }
    .el-transfer-panel__list.is-filterable{
      height: 234px;
    }
    .el-form-item__label{ color: #333; font-size: 14px;}
    .el-form-item .item{
      color: #666;
      span{
        color: #999;
      }
    }
    .dioTit{
      font-size: 16px;
      color: #333;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .s {
        font-size: 12px;
        font-weight: normal;
      }
    }
    .col6{
      color: #666;
    }
    .hintColor {
      color: #f95757;
    }
    .dioList{
      display: flex;
      flex-wrap: wrap;
      padding-top: 10px;
      .item{
        width: 112px;
        text-align: center;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding:10px 5px;
        margin: 0 10px 10px;
        box-sizing: border-box;
        font-size: 14px;
        color: #666;
        line-height: 24px;
      }
    }
  }
  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background: none;
    .label{
      // color: #409EFF;
    }
  }
  .el-dialog__body{
    padding:10px 20px;
  }
  .authDio{
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit{
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .authUser{
      border:1px solid #e4e7ed;
      align-items: flex-start;
      .userTree{
        width: 200px;
        border-right: 1px solid #e4e7ed;
        height: 300px;
        overflow-y: auto;
      }
      .checkList{
        flex: 1;
        height: 300px;
        position: relative;
        display: flex;
        flex-direction: column;
        .topArea {
          flex-shrink: 0;
          // 搜索
          .search {
            width: 260px;
            margin: 10px auto;
            input {
              border-radius: 32px;
            }
          }
          // 标题
          .titArea {
            padding: 0 20px 10px;
            border-bottom: 1px solid #eee;
            display: flex;
            .left {
              width: 50%;
              margin-right: 2%;
            }
          }
        }
        .checkItemBox{
          max-height: 100%;
          overflow-y: auto;
          padding: 10px 20px 0;
          display: flex;
          flex-wrap: wrap;
          &.CPL {
            display: block;
            .checkItem {
              width: 100%;
              display: flex;
              .checkbox {
                flex-shrink: 0;
                width: 20%;
                &.user_name {
                  width: 50%;
                  margin-right: 5%;
                }
                &.switch {
                  margin-right: 5%;
                }
              }
            }
          }
          .checkItem{
            width: 33.33%;
            .checkbox{ 
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .el-checkbox__label{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  .mainBodyContent::after{
    height: 100%;
    content: '';
    border-right: 1px solid #E4E7ED;
    position: absolute;
    left: 270px;
    top: 0;
  }
  .mainBodyContent{
    padding: 0;
    position: relative;
    .authCont{
      display: flex;
      .authLeft{
        overflow-y:auto;
        width: 270px;
        flex-shrink: 0;
        .tit{
          height: 40px;
          line-height: 40px;
          padding: 0 20px 0 10px;
          border-bottom: 1px solid #e4e7ed;
          font-weight: bold;
        }
        .pd10{ padding: 10px;}
      }
      .authRight{
        flex-grow:1;
        padding: 20px;
        .operDiv{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .colRed{ color: red;}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CSceneManage/CDeviceManage/CDeviceManageDevice.vue